import React, { useState } from 'react';
import RichTextEditor from './RichTextEditor';

const CATEGORIES = ['general', 'moderation', 'account', 'announcement', 'community', 'system'];

const TemplateEditorModal = ({ template, onSave, onClose, saving }) => {
    const [name, setName] = useState(template?.name || '');
    const [category, setCategory] = useState(template?.category || 'general');
    const [description, setDescription] = useState(template?.description || '');
    const [subjectTemplate, setSubjectTemplate] = useState(template?.subjectTemplate || '');
    const [bodyHtmlTemplate, setBodyHtmlTemplate] = useState(template?.bodyHtmlTemplate || '');

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({ ...template, name, category, description, subjectTemplate, bodyHtmlTemplate });
    };

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', width: '720px', maxWidth: '92vw', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>
                <form onSubmit={handleSubmit}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h3 style={{ margin: 0, fontWeight: 700, fontSize: '20px', color: '#002244' }}>
                            {template?.id ? 'Edit Template' : 'New Template'}
                        </h3>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Name</label>
                        <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">Category</label>
                            <select className="form-select" value={category} onChange={(e) => setCategory(e.target.value)}>
                                {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">Description</label>
                            <input className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Subject template</label>
                        <input className="form-control" value={subjectTemplate} onChange={(e) => setSubjectTemplate(e.target.value)} placeholder="e.g. Welcome, {{firstName}}!" required />
                    </div>
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Body template</label>
                        <RichTextEditor value={bodyHtmlTemplate} onChange={setBodyHtmlTemplate} />
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-3">
                        <button type="button" className="btn btn-light" onClick={onClose} disabled={saving}>Cancel</button>
                        <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Save Template'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TemplateEditorModal;
